import { Base } from "ui/Scripts/source/framework/base";
import { FileType, Permission } from "ui/Scripts/source/models/enums";

export interface IFolderTreeNode {
    id: string;
    name: string;
    comment: string;
    image: string;
    permission: Permission;
    fileType: FileType;
    children: IFolderTreeNode[];
    parent: IFolderTreeNode;
    level: number;
    expanded: boolean;
    
    getIsRoot(): boolean;
    getAncesterIsCollapsed(): boolean;
    getAsList(list: IFolderTreeNode[], level: number): IFolderTreeNode[];
    removeReadOnlyBranches();
    getFullPath(): string;
    expandToRoot();
}

export class FolderTreeNode implements IFolderTreeNode {
    id: string;
    name: string;
    comment: string;
    image: string;
    permission: Permission;
    fileType: FileType;
    children: IFolderTreeNode[];
    parent: IFolderTreeNode;
    level: number;
    expanded: boolean;

    constructor();
    constructor(obj: IFolderTreeNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.image = obj && obj.image || "";
        this.permission = obj && obj.permission || Permission.None;
        this.fileType = obj && obj.fileType || FileType.Unknown; // Unknown = folder
        this.expanded = obj && obj.expanded || false;
        this.children = [];
        this.parent = null;
        if (obj && obj.children) {
            this.children = Base.getTypedArray(obj.children, FolderTreeNode);
            for (const child of this.children) {
                child.parent = this;
            }
        }
    }

    getAsList(list: IFolderTreeNode[], level: number = 0): IFolderTreeNode[] {
        list.push(this);
        this.level = level;
        if (this.children.length < 1) return list;
        for (const child of this.children) {
            child.getAsList(list, level + 1);
        }
        return list;
    }

    getIsRoot(): boolean {
        return !this.parent;
    }

    getAncesterIsCollapsed(): boolean {
        if (!this.parent) return false;
        if (!this.parent.expanded) return true;
        return this.parent.getAncesterIsCollapsed();
    }

    removeReadOnlyBranches() {
        for (const child of this.children) {
            child.removeReadOnlyBranches();
        }
        if (this.parent) {
            if (this.permission < Permission.Edit && this.children.length < 1) {
                this.parent.children = this.parent.children.filter(i => i.id !== this.id);
            }
        }
    }

    getFullPath(): string {
        return this.parent
            ? this.parent.getFullPath() + "\\" + this.name
            : this.name;
    }

    expandToRoot() {
        if (!this.parent) return;
        this.parent.expanded = true;
        this.parent.expandToRoot();
    }
}